module.exports = "/assets/data/e80356591f157ea5c6a8af842b260b23-CM18.data.json";